import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { API_V3, getSomethingPaginated } from './types';

export interface ListIntegrationsRequest {
  accountId: number;
  projectId: number;
}

export const useIntegrations = ({
  accountId,
  projectId,
  enabled = true,
}: ListIntegrationsRequest & { enabled?: boolean }) => {
  return useQuery<Integration[], AxiosError>({
    queryKey: ['integration'],
    queryFn: () => listIntegrations({ accountId, projectId }),
    enabled: enabled && !!accountId && !!projectId,
  });
};

export const listIntegrations = async ({
  accountId,
  projectId,
}: ListIntegrationsRequest): Promise<Integration[]> => {
  return await getSomethingPaginated<Integration>(
    API_V3,
    `/accounts/${accountId}/projects/${projectId}/integrations/lineage/`,
    {},
  );
};

export interface Integration {
  id: number;
  account_id: number;
  project_id: number;
  name: string;
}
